"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.accessScopeToJSON = exports.accessScopeFromJSON = exports.AccessScope = void 0;
var AccessScope;
(function (AccessScope) {
  AccessScope[AccessScope["PRIVATE"] = 0] = "PRIVATE";
  AccessScope[AccessScope["PUBLIC"] = 1] = "PUBLIC";
  AccessScope[AccessScope["RESTRICTED"] = 2] = "RESTRICTED";
  AccessScope[AccessScope["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(AccessScope = exports.AccessScope || (exports.AccessScope = {}));
function accessScopeFromJSON(object) {
  switch (object) {
    case 0:
    case "PRIVATE":
      return AccessScope.PRIVATE;
    case 1:
    case "PUBLIC":
      return AccessScope.PUBLIC;
    case 2:
    case "RESTRICTED":
      return AccessScope.RESTRICTED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AccessScope.UNRECOGNIZED;
  }
}
exports.accessScopeFromJSON = accessScopeFromJSON;
function accessScopeToJSON(object) {
  switch (object) {
    case AccessScope.PRIVATE:
      return "PRIVATE";
    case AccessScope.PUBLIC:
      return "PUBLIC";
    case AccessScope.RESTRICTED:
      return "RESTRICTED";
    case AccessScope.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
exports.accessScopeToJSON = accessScopeToJSON;